import React from 'react';
import Matrix from 'pu-react/components/PriceMatrix';
import PriceMatrixCell from './PriceMatrixCell';

const PriceMatrix = (props) => {
  const { supplier } = props;

  return (
    <div className="price-matrix">
      <div className="head clearfix">
        <div className="supplier-logo">
          <img src={supplier.logo} alt={supplier.title} />
        </div>
        <div className="supplier-description">
          <h3 className="title">{supplier.title}</h3>
        </div>
      </div>
      <div className="body">
        <div className="matrix-wrap">
          <Matrix
            {...props}
            matrixCell={PriceMatrixCell}
            combined="0" />
        </div>
      </div>
    </div>
  );
};

export default PriceMatrix;
